import React from 'react';

export const TrackTablePriceCell = (price): JSX.Element => {
  return <span>{price || 'unknown'} ₽</span>;
};
